import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-model",
  "use": "icon-model-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-model\">\n  <path d=\"M8 2h8v2h2a2 2 0 0 1 2 2v2h2v8h-2v2a2 2 0 0 1-2 2h-2v2H8v-2H6a2 2 0 0 1-2-2v-2H2V8h2V6a2 2 0 0 1 2-2h2V2zm-2 4v12h12V6H6zm3 3h6v6H9V9zm2 2v2h2v-2h-2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol